import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import PrescribingLocationForm from './PrescribingForm';
import { AppDispatch } from 'state/store';
import { Row } from 'react-bootstrap';
import { CirclePlus } from 'assets/icons/CirclePlus';

interface PrescribingLocationProps {
  onClear: any;
  card?: boolean;
  registerForm?: boolean;
  isDisabled?: boolean;
  dispatch: AppDispatch;
  formId: string;
  methods: any;
  isSubmitted: boolean;
}

function PrescribingLocation({
  onClear,
  card,
  registerForm,
  isDisabled,
  dispatch,
  formId,
  methods,
  isSubmitted,
}: PrescribingLocationProps) {
  const [locationForm, setLocationForm] = useState<number[]>([0]);

  const [index, setIndex] = useState(1);

  const addLocationForm = () => {
    setLocationForm([...locationForm, index]);
    setIndex(index + 1);
  };
  const removeLocationForm = async () => {
    setLocationForm(locationForm.slice(0, -1));
    await onClear(dispatch, formId, methods, isSubmitted, index - 1, registerForm);
    setIndex(index - 1);
  };

  return (
    <>
      <div className={card ? 'card mb-2' : ''}>
        <Row className="py-1">
          <div className="pb-3">
            This must reflect the location address to be included on an electronic prescription.
            i.e. where the patient is visiting you. Please ensure you setup all location(s) where
            you'll be prescribing XYWAV or XYREM.
          </div>

          {locationForm.map((index: number) => {
            return (
              <PrescribingLocationForm
                key={index}
                index={index}
                registerForm={registerForm}
                isDisabled={isDisabled}
              />
            );
          })}
        </Row>

        <Row className="pb-3">
          <div className="link-primary">
            <i
              id="add-location-i-register"
              className={`text-purple fw-bold btn btn-link ps-0
                ${
                  !isDisabled
                    ? 'fa fa-plus cursor-pointer location-form '
                    : 'location-form add-remove-disable '
                }`}
              aria-hidden="true"
              onClick={!isDisabled ? addLocationForm : undefined}
            >
              <div className="d-flex">
                <div className="d-flex justify-content-center align-items-center fw-bold">
                  <CirclePlus />
                </div>
                <div className="ms-1">&nbsp;Add Another Location</div>
              </div>
            </i>
            {locationForm.length > 1 && (
              <i
                id="remove-location-i-register"
                className={`text-purple fw-bold btn btn-link ps-0 ${
                  !isDisabled
                    ? 'fa fa-plus cursor-pointer location-form '
                    : 'location-form add-remove-disable '
                }`}
                aria-hidden="true"
                onClick={!isDisabled ? removeLocationForm : undefined}
              >
                <FontAwesomeIcon
                  icon={faMinus}
                  className="primary"
                />
                &nbsp;Remove Last Location
              </i>
            )}
          </div>
        </Row>
      </div>
    </>
  );
}

export default PrescribingLocation;
